import React from 'react';

const Guide = () => {
    return (
        <div className="App">
            <img src="https://image.freepik.com/free-vector/coming-soon-construction-yellow-background-design_1017-25509.jpg" alt="" />
        </div>
    );
};

export default Guide;